// src/components/ViewportControls.tsx

import React from 'react';
import type { BuildingForRender, RoadForRender } from '../hooks/useCityData';
import styles from './ViewportControls.module.css';

export interface ViewportControlsProps {
  selectedBuilding: BuildingForRender | null;
  selectedRoad: RoadForRender | null;
  showBuildings: boolean;
  onToggleBuildings: () => void;
  onRefresh: () => void;
  onExportScene: () => void;
  onExportSelected: () => void;
  onDeleteSelected: () => void;
  hasSelection: boolean;
  objectsCount: number;
}

export const ViewportControls: React.FC<ViewportControlsProps> = ({
  selectedBuilding,
  selectedRoad,
  showBuildings,
  onToggleBuildings,
  onRefresh,
  onExportScene,
  onExportSelected,
  onDeleteSelected,
  hasSelection,
  objectsCount,
}) => {
  return (
    <>
      {/* Overlay informativo (superior izquierda) */}
      <div className={styles.infoOverlay}>
        <div>
          <strong>Edificio:</strong>{' '}
          {selectedBuilding?.name ||
            (selectedBuilding ? `ID: ${selectedBuilding.id}` : 'Ninguno')}
        </div>
        {selectedBuilding && (
          <div className={styles.details}>
            <div>Altura: {selectedBuilding.height.toFixed(1)} m</div>
            {selectedBuilding.buildingType && (
              <div>Tipo: {selectedBuilding.buildingType}</div>
            )}
          </div>
        )}
        <div className={styles.roadSection}>
          <strong>Calle:</strong>{' '}
          {selectedRoad?.name || (selectedRoad ? `ID: ${selectedRoad.id}` : 'Ninguna')}
        </div>
        {selectedRoad && (
          <div className={styles.details}>
            <div>Tipo: {selectedRoad.highwayType}</div>
            <div>Puntos: {selectedRoad.points.length}</div>
          </div>
        )}
      </div>

      {/* Botones de control del viewport (inferior izquierda) */}
      <div className={styles.controlsBar}>
        <button
          onClick={onRefresh}
          title="Recargar datos del sitio desde el JSON local"
          className={styles.btnRefresh}
        >
          ↻
        </button>
        <button
          onClick={onToggleBuildings}
          title={showBuildings ? 'Ocultar edificios' : 'Mostrar edificios'}
          className={`${styles.btnToggle} ${
            showBuildings ? styles.btnToggleActive : styles.btnToggleInactive
          }`}
        >
          {showBuildings ? '👁' : '🚫'}
        </button>
        <button
          onClick={onExportScene}
          disabled={objectsCount === 0}
          title="Exportar toda la escena (edificios y calles) a JSON"
          className={styles.btnExport}
        >
          ⭳ Escena
        </button>
        <button
          onClick={onExportSelected}
          disabled={!hasSelection}
          title="Exportar el objeto seleccionado a JSON"
          className={styles.btnExport}
        >
          ⬇ Seleccionado
        </button>
        <button
          onClick={onDeleteSelected}
          disabled={!hasSelection}
          title="Borrar el objeto seleccionado de la escena 3D"
          className={styles.btnDelete}
        >
          🗑
        </button>
        <span className={styles.statusText}>
          {showBuildings ? 'Edificios visibles' : 'Edificios ocultos'}
        </span>
      </div>
    </>
  );
};

export default ViewportControls;
